import { useToken } from "@/utils/hooksUtils";
import { GetProps, Tag } from "antd";

type Props = Omit<GetProps<typeof Tag.CheckableTag>, "checked"> & {
  checked?: boolean;
};

// The remaining props are passed on, so the tag also works as a Popover child, which adds a ref and its handlers.
export const CalcCheckableTag = ({ checked, style, ...props }: Props) => {
  const { token } = useToken();

  return (
    <Tag.CheckableTag
      {...props}
      checked={!!checked}
      style={{
        margin: 0,
        padding: "4px 10px",
        border: `1px solid ${checked ? token.colorPrimary : token.colorBorder}`,
        fontSize: 14,
        lineHeight: "22px",
        ...style,
      }}
    />
  );
};
